module.exports = __webpack_public_path__ + "img/issue-icon1.d67dbad.png";